export const  Getdata = "GET-DATA" ;
export const  GetBlog = "GET-BLOG" ;